<template>
    <div
        v-if="visible"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50"
    >
        <div v-if="!countdownActive" class="bg-white rounded-lg shadow-xl m-4 md:m-0 p-6 max-w-xl w-full">
            <h2 class="text-2xl font-bold mb-4 text-center">Select Your Game</h2>
            <div class="space-y-4">
                <div
                    v-for="(game, index) in games"
                    :key="index"
                    @click="selectGame(game)"
                    class="relative p-4 border rounded cursor-pointer"
                    :class="[
                        selectedGame && selectedGame.id === game.id ? 'border-blue-500 bg-blue-100' : 'border-gray-300',
                        game.disabled ? 'bg-gray-100 cursor-not-allowed' : ''
                    ]"
                >
                    <div :class="{'opacity-75': game.disabled }">
                        <p class="font-semibold">{{ game.title }}</p>
                        <p>{{ game.description }}</p>
                        <p class="text-sm text-gray-600">Starting money: {{ formatMoney(game.money) }}</p>
                    </div>

                    <span v-if="game.disabled" class="absolute bg-red-500 text-white text-xs px-2 py-1 rounded -top-2 -left-2 -rotate-3">Coming soon</span>
                </div>
            </div>
            <button
                class="mt-6 w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                :disabled="!selectedGame"
                @click="startCountdown"
            >
                Start Game
            </button>
        </div>
        <div v-else>
            <h2 class="text-9xl text-white font-bold text-center mb-4">{{ countdown }}</h2>
        </div>
    </div>
</template>
  
<script setup>
import { ref, watch, onUnmounted } from 'vue';
  
const props = defineProps({
    games: {
        type: Array,
        required: true,
        default: () => []
    },
    modelValue: {
        type: Boolean,
        default: false,
    }
});

const emit = defineEmits(['update:modelValue', 'select-game', 'start-game']);
  
// Control visibility via v-model.
const visible = ref(props.modelValue);
watch(
    () => props.modelValue,
    (newVal) => {
        visible.value = newVal;
    }
);
  
// Local state for the selected game and countdown.
const selectedGame = ref(null);
const countdownActive = ref(false);
const countdown = ref(3);
let countdownInterval = null;

function formatMoney(money) {
    const _money = money.map(m => `${m.symbol}${m.value}`).join(', ');
    return _money.length > 50 ? `${_money.slice(0, 50)}...` : _money;
}
  
function selectGame(game) {
    if (game.disabled) return;

    selectedGame.value = game;
    emit('select-game', game);
}
  
function startCountdown() {
    if (!selectedGame.value) return;
    countdownActive.value = true;
    countdown.value = 3;

    const beepAudio = new Audio("sounds/beep.mp3");
    const beepStartAudio = new Audio("sounds/beep-start.mp3");
    beepAudio.play();

    countdownInterval = setInterval(() => {
        countdown.value -= 1;
        if (countdown.value <= 0) {
            beepStartAudio.play();
            clearInterval(countdownInterval);
            emit('start-game', selectedGame.value);
            visible.value = false;
            emit('update:modelValue', false);
        } else {
            beepAudio.play();
        }
    }, 1000);
}
  
onUnmounted(() => {
    if (countdownInterval) clearInterval(countdownInterval);
});
</script>
